import { db } from "~/db/db";
import { normalize } from "./formatText";
import { ka } from "date-fns/locale";
import dateTimeBR from "~services/utils/formatDateHourBR";
import { getDeviceType } from "~services/utils/deviceInfo";

export const toFormatFunnel = ({data}) => {
  let toReturn = [];

  if (data.length) {
    data.map(e => {
      toReturn.push({
        ...e,
        
      })
    })
  }

  return toReturn;
}

export const fixObject = ({ obj }) => {
  const { funilStatusId, ...rest } = obj;

  return {
    ...rest,
    funilObraPaiId: obj.funilObraPaiId ?? obj.id ?? 0,
    dataNegociacao: obj.dataNegociacao?.substring(0, 10),
    dataHoraPesquisa: obj.dataHoraPesquisa ?? "",
    funilObraStatusId: funilStatusId,
    precoNecessario: obj.precoNecessario == null || obj.precoNecessario === '' || obj.precoNecessario === 0 ? null  : obj.precoNecessario
  };
};

export const getDevice = () => getDeviceType();

export const resetFunnel = async ({data, table = db.funilObraDashboard, clienteId}) => {
  try {
    let ids = []
    
    if(clienteId) {
      if(Array.isArray(clienteId)) {
        ids = await table.where('clienteId').anyOf(clienteId.map(Number)).primaryKeys();
      } else {
        ids = await table.where('clienteId').equals(Number(clienteId)).primaryKeys();
      }
    } else {
      ids = await table.orderBy('id').primaryKeys();
    }

    // Operação em uma transação
    await db.transaction('rw', table, async () => {
      await table.bulkDelete(ids);
      await table.bulkPut(data);
    });

    return {success: true};

  } catch (error) {
    return {success: false};
  }
};

export const updateData = async ({data, resetFunilObra = false, clienteId}) => {
  const searchs = [];

  for (const e of data) {
    searchs.push(e);
  }

  if(resetFunilObra) await resetFunnel({data: searchs, table: db.funilObraDashboard, clienteId});

  await resetFunnel({data: searchs, table: db.funilObra, clienteId});

  return {success: true};
}

const measureMap = {
  metro: "m³",
  tonelada: "t",
  unidade: "un",
  saco: "sc",
  litro: "L",
  balde: "bal",
  caixa: "cx",
};

export const getMeasure = (measure) => {
  const nome = normalize(measure);

  const entry = Object.entries(measureMap)
    .find(([key]) => nome.startsWith(key));

  return entry?.[1] ?? "";
};

export const formatDateByPattern = (date, pattern) => {
  pattern = pattern.trim().toLowerCase();
  const dd = String(date.getDate()).padStart(2, "0");
  const MM = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  const yy = String(yyyy).slice(-2);

  return pattern
    .replace("dd", dd)
    .replace("mm", MM)
    .replace("yyyy", yyyy)
    .replace("yy", yy);
};

export const isValidBRDate = (value) => {
  if (!value) {
    return false;
  }

  const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

  if (!match) {
    return false;
  }

  const [, day, month, year] = match;

  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === Number(year) &&
    date.getMonth() === Number(month) - 1 &&
    date.getDate() === Number(day)
  );
};

export const isValidMonthYear = (value) => {
  if (!value) {
    return false;
  }

  const match = value.match(/^(\d{2})\/(\d{4})$/);

  if (!match) {
    return false;
  }

  const [, month, year] = match;

  const monthNumber = Number(month);
  const yearNumber = Number(year);

  return (
    monthNumber >= 1 &&
    monthNumber <= 12 &&
    yearNumber >= 0
  );
};

export const formatDate = (v) => {
  const digits = (v ?? "").replace(/\D/g, "")?.slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const formatMonthYear = (v) => {
  const digits = (v ?? "").replace(/\D/g, "").slice(0, 6);

  if (digits.length <= 2) return digits;

  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
};

export const formatFunnelData = ({funilObraGrupoProdutoObjeto = {}, funilObraUnidadeMedidaObjeto = {}, funilObraStatusObjeto = {}, revenues = {}, funil = [] }) => {

  if(funilObraGrupoProdutoObjeto && funilObraUnidadeMedidaObjeto &&
    Object.entries(funilObraGrupoProdutoObjeto)?.length && Object.entries(funilObraUnidadeMedidaObjeto)?.length && 
    Object.entries(funilObraStatusObjeto)?.length && funil) {
      const graphData = {};
      const billedClientGroups = new Set();

      const formattedFunnel = (funil || []).reduce((acc, cur) => {
        const key = cur.funilObraGrupoProdutoId ?? 0;

        const group =
          funilObraGrupoProdutoObjeto[`id-${key}`];

        const billedVolume = revenues[cur.clienteId]?.[`id-${key}`] ?? 0;

        const measure =
          funilObraUnidadeMedidaObjeto[`id-${cur.funilObraUnidadeMedidaId}`];

        const date = new Date(`${cur.dataNegociacao}T00:00:00`);

        const formats = {
          'br': formatDateByPattern(date, "dd/mm/YYYY"),
          'us': formatDateByPattern(date, "YYYY-mm-dd"),
          'ddMM': formatDateByPattern(date, "dd/mm  ")
        };

        if (group && measure) {
          const formattedMeasure = getMeasure(measure.nome ?? "") ?? "";
          acc[key] ??= {
            id: key,
            ordem: group.mapeamentoInicial,
            title: group.nome,
            funilObraGrupoProdutoId: key,
            funilObraUnidadeMedidaId: cur.funilObraUnidadeMedidaId,
            unidade: formattedMeasure,
            volumeMapeado: cur.volumeMapeado,
            volumeNegociado: cur.volumeNegociado,
            proximaNegociacao: cur.dataNegociacao,
            proximaNegociacaoFormatado: formats.ddMM ?? "",
            items: []
          };

          graphData[key] ??= {
            groupId: key, 
            label: `${group.nome.toUpperCase()} (${formattedMeasure})`,
            mapeado: 0,
            negociado: 0,
            faturado: 0
          }

          if (!acc[key].proximaNegociacao || cur.dataNegociacao > acc[key].proximaNegociacao) {
            acc[key].proximaNegociacao = cur.dataNegociacao;
          }

          acc[key].items.push({
            id: cur.id, 
            volumeMapeado: cur.volumeMapeado, 
            volumeNegociado: cur.volumeNegociado, 
            dataNegociacao: formatDateByPattern(date, "yyyy-mm"),
            status: cur.funilObraStatusId
          })

          acc[key].proximaNegociacaoFormatos = formats;

          graphData[key].mapeado += Number(cur.volumeMapeado ?? 0);
          graphData[key].negociado += Number(cur.volumeNegociado);
          const billedClientGroup = `${cur.clienteId}-${key}`;
          
          if (!billedClientGroups.has(billedClientGroup)) {
            graphData[key].faturado += Number(billedVolume);
            billedClientGroups.add(billedClientGroup);
          }
        }

        return acc;
      }, {});

      return {
        graphData: Object.entries(graphData).map(([k,v]) => ({
          ...v,
          mapeado: v?.mapeado !== 0 ? v.mapeado : null,
          negociado: v?.negociado !== 0 ? v.negociado : null,
          faturado: v?.faturado !== 0 ? v.faturado : null,
        })),
        formattedFunnel
      }
    }
}